




























import Aws from "aws-sdk";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RadialStripe, ScreenIndicator } from "../lib";
import EmailValidator from "email-validator";

@Component({
  components: {}
})
export default class DownloadComponent extends Vue {
  @Prop() private preview!: RadialStripe;
  @Prop() private indicator!: ScreenIndicator;
  private email = "";
  private error = "";

  get isValidEmail() {
    return EmailValidator.validate(this.email);
  }

  async download() {
    if (!this.isValidEmail) return;
    this.error = "";
    this.indicator.reset();
    this.indicator.loading = true;
    try {
      Aws.config.region = "ap-northeast-1"; // リージョン
      Aws.config.credentials = new Aws.CognitoIdentityCredentials({
        IdentityPoolId: "ap-northeast-1:708e5ae0-3976-45ff-be48-018599709134"
      });

      const sns = new Aws.SNS();
      const res = await sns
        .publish({
          TopicArn: 'arn:aws:sns:ap-northeast-1:187385158686:dr-capital',
          Message: JSON.stringify({
            email: this.email,
            radialStripe: this.preview
          }),
        })
        .promise();

      this.indicator.loading = false;
      this.$bvModal.show("downloaded-modal");
    } catch (ex) {
      console.error(ex)
      this.indicator.loading = false;
      this.error = ex;
    }
  }

  mounted() {
    const email = window.localStorage.getItem("email");
    if (email) this.email = email;
  }

  @Watch("email")
  onEmailChanged() {
    window.localStorage.setItem("email", this.email);
  }
}
